export default __webpack_public_path__ + "01CreateReport.b537a488.png";